import BodyText from 'LuxKit/Typography/BodyText'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import CalendarPickerRecommendations from './CalendarPickerRecommendations'
import { getRecommendationsTitleMobile } from './utils/recommendationsTitle'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

interface Props {
  checkIn: string
  monthIndex: string
  duration: number
  loadingState: 'loading' | 'done' | 'error'
  offerIds: Array<string>
  offer: App.Offer
  rooms: Array<App.Occupants>
}

function CalendarPickerRecommendationsSidebar({
  offer,
  checkIn,
  duration,
  monthIndex,
  loadingState,
  offerIds,
  rooms,
}: Props) {
  const intl = useIntl()

  const title = useMemo(() => getRecommendationsTitleMobile({
    checkIn,
    monthIndex,
    duration,
    intl,
    variant: 'available',
  }), [checkIn, duration, monthIndex, intl])

  const hasOffers = loadingState === 'done' && offerIds.length > 0

  return <VerticalSpacer gap={24}>
    {hasOffers && <BodyText variant="large" align="center" colour="neutral-two">{title}</BodyText>}
    <CalendarPickerRecommendations
      offerId={offer.id}
      offerType={offer.type}
      rooms={rooms}
      seedOffer={offer}
    />
  </VerticalSpacer>
}

export default withOfferPageAndReduxState((state, appState) => ({
  monthIndex: state.recommendationsMonthIndex,
  checkIn: state.recommendationsCheckInDay,
  offer: state.offer,
  offerIds: appState.recommendations.calendarRecommendations.offerIds,
  loadingState: appState.recommendations.calendarRecommendations.state,
  duration: state.duration,
  rooms: state.rooms,
}), CalendarPickerRecommendationsSidebar)
